import React from "react";
import { LocalServiceTemplate } from "@/components/local/LocalServiceTemplate";
import { localServiceData } from "@/data/localServiceData";

const LaadpaalWestervoort = () => {
  return <LocalServiceTemplate data={localServiceData['laadpaal-westervoort']} />;
};

export default LaadpaalWestervoort;